import { Component, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { PlanerGodkendt } from '@store/models';

@Component({
    selector: 'app-planer-godkendt-ui',
    templateUrl: './planer-godkendt.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PlanerGodkendtComponent {

    @Input() planerGodkendt: PlanerGodkendt[];
    @Output() gotoKundeEval = new EventEmitter<PlanerGodkendt>();
    @Output() updateSeen = new EventEmitter<number>();
    @Output() dismiss = new EventEmitter();

    onGotoKundeEval(client: PlanerGodkendt) {
        this.gotoKundeEval.emit(client);
    }

    onUpdateSeen(event, kid: number) {
        event.stopPropagation();
        this.updateSeen.emit(kid);
    }

    onDismiss() {
        this.dismiss.emit();
    }

}
